module.exports = __webpack_public_path__ + "img/0.c1abf420.png";